
// Import mmenu library
import * as mmenu from 'mmenu-js';

(function () {

  /**
   * Provides the off-canvas menu.
   *
   * @type {Drupal~behavior}
   *
   * @prop {Drupal~behaviorAttach} attach
   *   Attaches the behavior for the off-canvas menu.
   */
  Drupal.behaviors.responsive_menu_mmenu = {
    attach: function (context) {

      const mmenuId = '#off-canvas';
      const offCanvas = document.querySelector(mmenuId);

      // The instatiation of the mmenu must only happen once.
      if (offCanvas && !offCanvas.hasOwnProperty('mmApi') && typeof (Mmenu) !== 'undefined') {
        const settings = drupalSettings.responsive_menu;
        const position = settings.position,
              theme = settings.theme,
              pagedim = settings.pagedim;

        const options = {
          extensions: [
            theme,
            'fx-menu-slide',
          ],
          offCanvas: {
            position: position,
          },
          keyboardNavigation: {
            enable: true,
            enhance: true,
          },
          drag: {
            open: settings.drag
          },
        };

        if (pagedim !== 'none') {
          options.extensions.push(pagedim);
        }

        const config = {
          classNames: {
            selected: 'menu-item--active-trail'
          }
        };

        // Allow the settings and options to be extended or overridden.
        if (typeof settings.custom !== 'undefined') {
          if (typeof settings.custom.options !== 'undefined') {
            extend(options, drupalSettings.responsive_menu.custom.options);
          }
          if (typeof drupalSettings.responsive_menu.custom.config !== 'undefined') {
            extend(config, drupalSettings.responsive_menu.custom.config);
          }
        }

        // Set up the off canvas menu.
        const mmenu = new Mmenu(mmenuId, options, config);

        // Due to a rendering issue with Chrome the page needs the viewport
        // metatag to have a value including initial-scale=1.0 otherwise it
        // won't render properly.
        // @see issue #3153145
        const mmenuApi = mmenu.API;
        const viewports = document.getElementsByName('viewport');

        if (viewports.length !== 0 && settings.modifyViewport) {
          const viewportMeta = viewports[0]
          const defaultViewport = viewports[0].content
          const staticViewport = "width=device-width, initial-scale=1.0, minimum-scale=1.0";

          mmenuApi.bind('open:start', function() {
            viewportMeta.setAttribute('content', staticViewport);
          });
          mmenuApi.bind('close:start', function() {
            viewportMeta.setAttribute('content', defaultViewport);
          });
        }

        // Customizations

        // HTML wrap helper
        var wrap = (query, tag, attrs) => {
          document.querySelectorAll( query ).forEach( elem => {
            const newParent = document.createElement(tag);
            for(var key in attrs) {
              newParent.setAttribute(key, attrs[key]);
            }
            elem.parentElement.insertBefore(newParent, elem);
            newParent.appendChild(elem);
          });
        };

        // Wrap mobile menu in nav
        wrap('.mm-panels', 'nav', {'class': 'mm-panels-wrapper', 'aria-label': 'Mobile Menu'});

        // Change mobile menu title element
        wrap('.mm-panels .mm-navbar .mm-navbar__title', 'h2', {'class': 'mm-navbar__title', 'tabindex': '-1'});
        const navbarTitleSpan = document.querySelector('.mm-panels .mm-navbar .mm-navbar__title span');
        if (navbarTitleSpan !== null) {
          navbarTitleSpan.replaceWith(...navbarTitleSpan.childNodes);
        }

        // Handle toggle icon
        const toggleIcon = document.getElementById('toggle-icon');
        const closeMenuButton = document.querySelectorAll('.close-menu');
        const html = document.querySelector('html');

        toggleIcon.addEventListener('click', function (event) {
          event.preventDefault();
          mmenuApi.open();
          closeMenuButton.forEach(function(el) {
            el.focus();
          });
          this.setAttribute('aria-expanded', 'true');
          html.classList.add('no-scroll');
        });

        // Handle close button and call close method
        closeMenuButton.forEach(function(el) {
          el.addEventListener('click', function (event) {
            event.preventDefault();
            mmenuApi.close();
            toggleIcon.setAttribute('aria-expanded', 'false');
            toggleIcon.focus();
            html.classList.remove('no-scroll');
          });
        });

        // Handle close button and call close method
        document.querySelector('.mm-wrapper__blocker').addEventListener('click', function (event) {
            event.preventDefault();
            mmenuApi.close();
            toggleIcon.setAttribute('aria-expanded', 'false');
            toggleIcon.focus();
            html.classList.remove('no-scroll');
          });

        document.querySelectorAll('.mm-tabstart').forEach(function(el) {
          el.addEventListener('click', function () {
            toggleIcon.setAttribute('aria-expanded', 'false');
          });
        });

        // Send focus to title when navigating through menu levels
        document.querySelectorAll('.mm-btn--next, .mm-btn--prev').forEach(function(el) {
          el.addEventListener('click', function () {
            var menuId = this.getAttribute('href');

            if (menuId) {
              var menu = document.getElementById(menuId.substring(1));

              setTimeout(function() {
                var firstLink = menu.querySelector('.mm-listview').querySelector('a');
                if (firstLink) {
                  firstLink.focus();
                }
              }, 100);
            }
          });
        });

        // Remove unnecessary mmenu tabstart and tabend elements
        document.querySelectorAll('.mm-tabstart').forEach(function(el) {
          el.remove();
        });
        document.querySelectorAll('.mm-tabend').forEach(function(el) {
          el.remove();
        });

        // Mobile menu active trail
        document.querySelectorAll('.masthead__primary .menu--main .menu-item--active-trail').forEach(function(el) {
          var linkTitle = el.querySelector('.link-inner').textContent;
          document.querySelectorAll('.mm-listitem__text').forEach(function(el) {
            if(el.textContent === linkTitle){
              el.closest('.mm-listitem').classList.add('menu-item--active-trail');
            }
          });
        });

        // End of customizations
      }
    }
  };
})();

/**
 * Similar to the jQuery extend but shallow.
 *
 * @param out
 * @returns {*|{}}
 */
const extend = function (out) {
  out = out || {};

  for (let i = 1; i < arguments.length; i++) {
    if (!arguments[i])
      continue;

    for (let key in arguments[i]) {
      if (arguments[i].hasOwnProperty(key))
        out[key] = arguments[i][key];
    }
  }

  return out;
};
